import { h, Component } from 'preact';
import util from 'preact-util';
import { route } from 'preact-router';
import { observer } from 'mobx-preact';
import { Text, Localizer } from 'preact-i18n';
import Markdown from 'preact-markdown';

import localUtil from '../../lib/util';
import fields from '../../lib/fields';

import FormFields from '../../components/form/fields';
import FormFieldsCompact from '../../components/form/fieldsCompact';
import Input from '../../components/form/input';
import { appConfirm } from '../../lib/dialogs';
import { beginDialogAction } from '../../lib/dialogAction';

@observer
class UserProfileInline extends Component {
  	constructor(props) {
        super(props);
        const { appState } = this.props.stores;
        const { opts = {} } = appState;
        // const sections = ['User basics', 'User address', 'User settings', 'User email settings', 'Images, files and links'];
        // shootingSignup = convention (stevne) signup: only the shooting-relevant
        // fields (name, cellphone, email, sportsClub, skytterID) — no birth etc.
        const sections = props.shootingSignup ? ['User shooting signup'] : ['User basics'];
        const hideFields = [];

        if (!props.webshop && !props.shootingSignup) {
            hideFields.push(
                { name: 'cellphoneShadow' },
                { name: 'cellphone' },
                { name: 'email' },
                { name: 'nsfId' },
                { name: 'nsfClubNumber' },
            );
        }

        if (opts && opts.showRace) {
            sections.push('Race qualifying', 'Media', 'About yourself', 'User email settings');
            hideFields.push(
                { name: 'animaliaVeterinaryNumber' },
                { name: 'hprNumber' },
                { name: 'code' },
                { name: 'nsfId' },
                { name: 'nsfClubNumber' },
            );
        }

        if (opts && opts.showShooting) {
            hideFields.push(
                { name: 'animaliaVeterinaryNumber' },
                { name: 'hprNumber' },
                { name: 'code' },
                { name: 'licenseNumber' },
                { name: 'kennel' },
                { name: 'veteranRookie' },
                { name: 'qualifying' },
                { name: 'localNewsPaper' },
                { name: 'okToShareInfoWithMedia' },
                { name: 'rnb' },
                { name: 'sponsors' },
                { name: 'leadDogs' },
                { name: 'oldMerits' },
                { name: 'occupation' },
                { name: 'hobbies' },
                { name: 'funFacts' },
                { name: 'ambitions' },
                { name: 'settings.inboxEmails' },
                { name: 'settings.partnerEmails' },
                { name: 'okToShareInfoWithMedia' },
            );
        }

        if (opts && opts.showDyrejournal) {
            hideFields.push(
                { name: 'licenseNumber' },
                { name: 'sportsClub' },
                { name: 'sportsAssociation' },
                { name: 'kennel'},
                { name: 'nsfId'},
                { name: 'nsfClubNumber' },
            );
        }

        // Optionally hide the color picker (e.g. convention signup).
        if (props.hideColor) {
            hideFields.push({ name: 'color' });
        }

        // When the shooter's NSF id (skytterID) is required (e.g. convention signup),
        // make sure it is not hidden so it can be entered — it is crucial for reporting.
        let finalHideFields = [...new Set(hideFields)];
        if (props.requireNsfId) {
            finalHideFields = finalHideFields.filter(f => f.name !== 'nsfId');
        }

        // Optionally drop the newsletter/email settings section (e.g. convention signup).
        let sectionList = props.sections || sections;
        if (props.hideEmailSettings) {
            sectionList = sectionList.filter(s => s !== 'User email settings');
        }

        // 'Simple access code'
        this.state = {
            sections: fields.get('user', sectionList),
            hideFields: finalHideFields,
        };
    }

    showDeleteAccount = () => {
        this.setState({ showDeleteAccount: true });
    }

    hideDeleteAccount = () => {
        this.setState({ showDeleteAccount: false });
    }

    deleteAccount = async () => {
        const dialogAction = beginDialogAction(this, 'deleteAccount');
        if (!dialogAction) return false;
        try {
            const { userStore } = this.props.stores;
            const { user } = userStore;
            const { id } = user;
            if (!((await appConfirm('Are you sure you want to delete your account?')) && dialogAction.isCurrent())) {
                return;
            }
            await userStore.save({
                id,
                delete: true,
                deleteDate: new Date(),
            });
            this.setState({ accountMarkedForDeletion: true });
        } finally {
            dialogAction.finish();
        }
    }

    onDone = async () => {
        this.setState({ showEdit: false });
    }

    componentDidMount() {
        const { userStore } = this.props.stores;
        const { requireNsfId } = this.props;
        const { user } = userStore;
        if (!user.firstname || !user.lastname || (requireNsfId && !user.nsfId)) {
            this.setState({ showEdit: true });
        }
    }

    render() {
        const { sections, showDeleteAccount, accountMarkedForDeletion, hideFields, showEdit } = this.state;
        const { userStore, appState } = this.props.stores;
        const { opts, showEdit: showEditProp, readOnly, showDone } = this.props;
        const { drawerLevel } = this.props;
        const { user, isAdmin, isCustomerAdmin } = userStore;

        const effectiveHideFields = [...hideFields];
        if (!isAdmin && !isCustomerAdmin) {
            effectiveHideFields.push({ name: 'stampImage' });
        }
        const darkmode= util.getNestedValue(user, 'settings.darkmode');
        const image = localUtil.getImage({ user });
        const name = localUtil.displayName(user, true);

        if (!showEdit && !showEditProp) {
            return (<></>);
        }

        return (<>
            <div class='w-100 d-flex flex-column justify-content-start'>
                <div class='d-flex flex-column justify-content-start pt-0'>
                    <div style='padding: 0 8px;'>
                        <FormFieldsCompact
                            stores={this.props.stores}
                            sections={sections}
                            holdingStore={userStore}
                            objectName={'user'}
                            isNew={false}
                            drawerLevel={drawerLevel}
                            hideFields={effectiveHideFields}
                            hideAdmin={true}
                            readOnly={readOnly}
                            hideFilterToolbar={true}
                        />
                    </div>
                </div>
                {showDone && <div class='w-100 d-flex'>
                    <button type='button' class='btn btn-success btn-block rounded-pill mt-3' onClick={this.onDone}>
                        <Text id='user.profile-inline-done'>Done</Text>
                    </button>
                </div>}
            </div>
        </>);
    }
}

export default UserProfileInline;
